<template>
  <div>
    <v-dialog
      v-model="modalHistoricoSaldoBancoHoras"
      max-width="1200"
      class="dialog-deletado"
    >
      <v-card>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            id="close"
            text
            @click="modalHistoricoSaldoBancoHoras = false"
            height="39"
            class="
              font-weight-bold
              text-capitalize
              btn-ls btn-secondary
              bg-gradient-light
              py-3
              px-6
            "
          >
            {{ $t("Fechar") }}
          </v-btn>
        </v-card-actions>
        <v-card-title class="headline"
          >{{ $t("Saldo Banco de Horas") }}
        </v-card-title>

        <v-data-table
          :headers="headerHistoricoSaldoBancoHoras"
          :items="listagemHistoricoSaldobancohoras"
          class="elevation-1"
          disable-pagination
        >
          <template v-slot:[`item.periodo.inicioPeriodo`]="{ item }">
            {{ item.periodo.inicioPeriodo | dataParaLeitura }}
          </template>

          <template v-slot:[`item.periodo.finalPeriodo`]="{ item }">
            <span>{{ item.periodo.finalPeriodo | dataParaLeitura }}</span>
          </template>

          <template v-slot:[`item.movimentacaoBancoHorasPeriodo`]="{ item }">
            <span>
              {{ formatarValor(item.movimentacaoBancoHorasPeriodo) }}</span
            >
          </template>
          <template v-slot:[`item.saldoBancoHoras`]="{ item }">
            <span> {{ formatarValor(item.saldoBancoHoras) }}</span>
          </template>
        </v-data-table>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="modalHistoricoBeneficios"
      max-width="1200"
      class="dialog-deletado"
    >
      <v-card>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            id="close"
            text
            @click="modalHistoricoBeneficios = false"
            height="39"
            class="
              font-weight-bold
              text-capitalize
              btn-ls btn-secondary
              bg-gradient-light
              py-3
              px-6
            "
          >
            {{ $t("Fechar") }}
          </v-btn>
        </v-card-actions>
        <v-card-title class="headline"
          >{{ $t("Beneficio_apuracao") }}
        </v-card-title>

        <v-data-table
          :headers="headerHistoricoBeneficios"
          :items="listagemHistoricoBeneficios"
          class="elevation-1"
          disable-pagination
        >
          <template v-slot:[`item.data`]="{ item }">
            <span>{{ item.data | dataParaLeitura }}</span>
          </template>

          <template v-slot:[`item.status`]="{ item }">
            <span> {{ $t(item.status) }}</span>
          </template>

          <template v-slot:[`item.vaTotal`]="{ item }">
            <span v-if="item.vaTotal >= 0">
              {{ item.vaTotal | formatoMonetario }}</span
            >
            <span v-else style="color: red">{{
              item.vaTotal | formatoMonetario
            }}</span>
          </template>

          <template v-slot:[`item.vtTotal`]="{ item }">
            <span v-if="item.vtTotal >= 0">
              {{ item.vtTotal | formatoMonetario }}</span
            >
            <span v-else style="color: red">{{
              item.vtTotal | formatoMonetario
            }}</span>
          </template>

          <template v-slot:[`item.vrTotal`]="{ item }">
            <span v-if="item.vrTotal >= 0">
              {{ item.vrTotal | formatoMonetario }}</span
            >
            <span v-else style="color: red">{{
              item.vrTotal | formatoMonetario
            }}</span>
          </template>

          <template v-slot:[`item.outrosTotal`]="{ item }">
            <span v-if="item.outrosTotal >= 0">
              {{ item.outrosTotal | formatoMonetario }}</span
            >
            <span v-else style="color: red">{{
              item.outrosTotal | formatoMonetario
            }}</span>
          </template>

          <template v-slot:[`item.valorTotal`]="{ item }">
            <span v-if="item.valorTotal >= 0">
              {{ item.valorTotal | formatoMonetario }}</span
            >
            <span v-else style="color: red">{{
              item.valorTotal | formatoMonetario
            }}</span>
          </template>

          <template v-slot:[`item.beneficioConvenio.inicioPeriodo`]="{ item }">
            {{ item.beneficioConvenio.inicioPeriodo | dataParaLeitura }}
          </template>

          <template v-slot:[`item.beneficioConvenio.finalPeriodo`]="{ item }">
            {{ item.beneficioConvenio.finalPeriodo | dataParaLeitura }}
          </template>
        </v-data-table>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="modalBeneficiosOptante"
      max-width="1200"
      class="dialog-deletado"
    >
      <v-card>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            id="close"
            text
            @click="modalBeneficiosOptante = false"
            height="39"
            class="
              font-weight-bold
              text-capitalize
              btn-ls btn-secondary
              bg-gradient-light
              py-3
              px-6
            "
          >
            {{ $t("Fechar") }}
          </v-btn>
        </v-card-actions>
        <v-card-title class="headline"
          >{{ $t("Listagem_de_beneficioconvenios") }}
        </v-card-title>

        <v-data-table
          :headers="headerBeneficiosOptante"
          :items="listagemBeneficiosOptante"
          class="elevation-1"
          disable-pagination
        >
          <template v-slot:[`item.data`]="{ item }">
            <span>{{ item.data | dataParaLeitura }}</span>
          </template>

          <template v-slot:[`item.status`]="{ item }">
            <span> {{ $t(item.status) }}</span>
          </template>

          <template v-slot:[`item.beneficioConvenio.valorUnitario`]="{ item }">
            <span v-if="item.beneficioConvenio.valorUnitario >= 0">
              {{
                item.beneficioConvenio.valorUnitario | formatoMonetario
              }}</span
            >
            <span v-else style="color: red">{{
              item.beneficioConvenio.valorUnitario | formatoMonetario
            }}</span>
          </template>
          <template v-slot:[`item.inicio`]="{ item }">
            <span>{{ item.inicio | dataHoraParaLeitura }}</span>
          </template>
          <template v-slot:[`item.encerramento`]="{ item }">
            <span>{{ item.encerramento | dataHoraParaLeitura }}</span>
          </template>
        </v-data-table>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="modalDocumentacaoAcessoria"
      max-width="1200"
      class="dialog-deletado"
    >
      <v-card>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            text
            @click="printSelectedDocumentacaoAcessoria"
            height="39"
            class="
              font-weight-bold
              text-capitalize
              btn-ls btn-primary
              bg-gradient-primary
              py-3
              px-6
              mr-2
            "
            :disabled="!documentacaoAcessoriaSelecionada.length"
            :loading="loading"
          >
            <v-icon left dark>ni-collection</v-icon>
            {{ $t("Imprimir") }}
            <span v-if="documentacaoAcessoriaSelecionada.length">
              ({{ documentacaoAcessoriaSelecionada.length }})
            </span>
          </v-btn>
          <v-btn
            id="close"
            text
            @click="closeModalDocumentacaoAcessoria"
            height="39"
            class="
              font-weight-bold
              text-capitalize
              btn-ls btn-secondary
              bg-gradient-light
              py-3
              px-6
            "
            :loading="loading"
          >
            {{ $t("Fechar") }}
          </v-btn>
        </v-card-actions>
        <v-card-title class="headline"
          >{{ $t("documentacaoacessoria") }}
        </v-card-title>

        <v-data-table
          :headers="headerDocumentacaoAcessoria"
          :items="listagemDocumentacaoAcessoria"
          v-model="documentacaoAcessoriaSelecionada"
          item-key="id"
          show-select
          class="elevation-1"
          disable-pagination
        >
          <template v-slot:[`item.dtInclusao`]="{ item }">
            <span>{{ item.dtInclusao | dataParaLeitura }}</span>
          </template>
          <template v-slot:[`item.assinado`]="{ item }">
            <span>{{ item.assinado ? $t("sim") : $t("nao") }}</span>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-icon
              small
              name="printBtn"
              class="mr-2"
              :label="$t('Imprimir')"
              :title="$t('Imprimir')"
              @click="printSingle(item)"
              color="#67748e"
              >ni-collection</v-icon
            >
          </template>
        </v-data-table>
      </v-card>
    </v-dialog>

    <v-dialog v-model="modalGed" max-width="1400" class="dialog-deletado">
      <v-card>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            @click="modalNewDocGed = true"
            height="39"
            class="
              font-weight-bold
              text-none
              btn-primary
              bg-gradient-primary
              px-6
            "
            v-can="'ROLE_FuncionarioGed_Insert'"
            :loading="loading"
          >
            {{ $t("novo_registro") }}
          </v-btn>
          <v-btn outlined color="primary" height="39"
            class="text-none font-weight-bold" @click="alternarArquivadosGed">
            <v-icon left>mdi-archive-outline</v-icon>
            {{ mostrarArquivadosGed ? $t("ged_ativos") : $t("ged_arquivados") }}
          </v-btn>
          <v-btn
            @click="modalGed = false"
            height="39"
            class="
              font-weight-bold
              text-capitalize
              btn-ls btn-secondary
              bg-gradient-light
              px-6
            "
            :loading="loading"
          >
            {{ $t("Fechar") }}
          </v-btn>
        </v-card-actions>
        <v-card-title class="headline">{{ $t("GED") }} </v-card-title>

        <v-data-table
          :headers="headerGed"
          :items="mostrarArquivadosGed ? gedArquivados : listagemGed"
          class="elevation-1"
          disable-pagination
        >
          <template v-slot:[`item.dtInclusao`]="{ item }">
            <span>{{ item.dtInclusao | dataParaLeitura }}</span>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-icon
              v-if="!item.excluido"
              small
              class="mr-2"
              :title="$t('Baixar')"
              @click="downloadAnexo(item)"
              color="#67748e"
              >mdi-download</v-icon
            >
            <v-icon
              small
              class="mr-2"
              v-if="!item.excluido"
              :title="$t('ged_abrir_endereco_temporario')"
              @click="abrirEnderecoGed(item.id)"
              color="#67748e"
            >mdi-open-in-new</v-icon>
            <v-icon
              small
              class="mr-2"
              :title="$t('ged_historico_titulo')"
              @click="abrirHistoricoGed(item)"
              color="#67748e"
            >mdi-history</v-icon>
            <v-icon
              v-can="'ROLE_FuncionarioGed_Delete'"
              v-if="!item.excluido"
              small
              name="deleteBtn"
              class="mr-2"
              :label="$t('ged_arquivar')"
              :title="$t('ged_arquivar')"
              @click="deleteAnexo(item)"
              color="#67748e"
            >
              mdi-archive-outline</v-icon
            >
            <v-icon
              v-can="'ROLE_FuncionarioGed_Delete'"
              v-if="item.excluido"
              small
              :title="$t('ged_restaurar')"
              @click="restaurarGed(item)"
              color="#67748e"
            >mdi-restore</v-icon>
          </template>
        </v-data-table>
      </v-card>
    </v-dialog>

    <FuncionarioGedHistorico
      v-model="modalHistoricoGed"
      :documento="gedSelecionado"
      @updated="reloadFilesGed"
    />

    <v-dialog v-model="modalNewDocGed" max-width="800" class="dialog-deletado">
      <v-card>
        <v-card-title>{{ $t("ged_novo_documento") }}</v-card-title>
        <v-card-text>
          <v-form ref="form">
            <v-text-field v-model="descricao" label="Descrição documento" />

            <v-file-input @change="changeFile" label="Arquivo" accept=".pdf" />
          </v-form>
        </v-card-text>
        <v-card-actions class="crud-form-actions">
          <v-btn
            height="39"
            class="
              font-weight-bold
              text-capitalize
              btn-ls btn-secondary
              bg-gradient-light
              px-6
            "
            @click="closeModalNewGed()"
            :loading="loading"
          >
            {{ $t("Fechar") }}</v-btn
          >
          <v-btn
            height="39"
            class="
              font-weight-bold
              text-none
              btn-primary
              bg-gradient-primary
              px-6
            "
            @click="newDocGedFunction()"
            :loading="loading"
            >{{ $t("Enviar") }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="modalHistoricoSalarios" max-width="1100">
      <v-card>
        <v-card-title class="headline">
          {{ $t("Historico_de_salarios") }}
          <v-spacer></v-spacer>
          <v-btn
            text
            height="39"
            class="
              font-weight-bold
              text-capitalize
              btn-ls btn-secondary
              bg-gradient-light
              py-3
              px-6
            "
            @click="modalHistoricoSalarios = false"
            >{{ $t("Fechar") }}</v-btn
          >
        </v-card-title>
        <v-card-text>
          <v-data-table
            :headers="headerHistoricoSalarios"
            :items="historicoSalarios"
            :loading="carregandoHistoricoSalarios"
            :no-data-text="$t('Historico_de_salarios_vazio')"
            item-key="id"
            class="elevation-1"
            disable-pagination
            hide-default-footer
          >
            <template v-slot:[`item.competencia`]="{ item }">
              {{
                item.competencia
                  ? mesSalario(item.competencia)
                  : $t("Desde_admissao")
              }}
              <v-chip
                v-if="item.vigente"
                x-small
                color="green darken-1"
                outlined
                class="ml-1"
                >{{ $t("Vigente") }}</v-chip
              >
            </template>
            <template v-slot:[`item.salario`]="{ item }">
              <strong>{{ moedaSalario(item.salario) }}</strong>
              <div class="text-caption text--secondary">
                {{ item.salarioUnidadeDescricao }}
              </div>
            </template>
            <template v-slot:[`item.salarioAnterior`]="{ item }">
              {{
                item.salarioAnterior === null ||
                item.salarioAnterior === undefined
                  ? "-"
                  : moedaSalario(item.salarioAnterior)
              }}
            </template>
            <template v-slot:[`item.responsavel`]="{ item }">
              {{ item.responsavel || "-" }}
            </template>
            <template v-slot:[`item.dtInclusao`]="{ item }">
              {{ dataHoraSalario(item.dtInclusao) }}
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>

    <EditarBase
      :itemAtual="itemAtual"
      :recursoInicial="recursoInicial"
      nomeSingular="Funcionario"
      nomePlural="Funcionarios"
      :titulo="isOrgaoPublico ? 'editar.servidor' : ''"
      :campos-obrigatorios="camposObrigatorios"
      @recurso="recurso = $event"
      @submitSuccess="emitSubmitSuccess"
      @submitError="emitSubmitError"
      @closeModalEdit="closeModalEdit"
    >
      <v-col cols="12">
        <v-row>
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header>{{
                this.$t("Dados_pessoais")
              }}</v-expansion-panel-header>

              <v-expansion-panel-content>
                <v-row>
                  <v-col
                    cols="12"
                    md="12"
                    v-can="'ROLE_Funcionario_UpdatePerson'"
                  >
                    <TabelaSelecionaRecurso
                      @recurso="recurso.pessoa = $event"
                      field-name="pessoa"
                      :payload="recurso.pessoa"
                      :editar="false"
                      url="pessoas"
                      cadastro-url="cadastro.Pessoa"
                      titulo="Pessoa"
                      :headers="[
                        {
                          text: this.$t('Nome'),
                          value: 'nome',
                          sortable: 'false',
                        },
                        {
                          text: this.$t('CPF'),
                          value: 'cpf',
                          sortable: 'false',
                        },
                        {
                          text: this.$t('Email'),
                          value: 'email',
                          sortable: 'false',
                        },
                        {
                          text: this.$t('Acoes'),
                          value: 'actions',
                          sortable: false,
                        },
                      ]"
                    />
                  </v-col>

                  <v-col cols="12" sm="4" md="4">
                    <span class="opacity-5 text-dark">
                      {{ $t("Data_de_nascimento") }}
                    </span>
                    <CampoData
                      @date="recurso.dtNascimento = $event"
                      :label="$t('Data_de_nascimento')"
                      :payload="recurso.dtNascimento"
                    />
                  </v-col>

                  <v-col cols="12" md="4">
                    <span class="opacity-5 text-dark">
                      {{ $t("Instrucao") }}
                    </span>
                    <v-select
                      :items="[
                        { text: $t('Analfabeto'), value: 'ANALFABETO' },
                        {
                          text: $t('Quinto_ano_incompleto'),
                          value: 'QUINTOANOINCOMPLETO',
                        },
                        {
                          text: $t('Quinto_ano_completo'),
                          value: 'QUINTOANOCOMPLETO',
                        },
                        {
                          text: $t('Fundamental_incompleto'),
                          value: 'FUNDAMENTALINCOMPLETO',
                        },
                        {
                          text: $t('Fundamental_completo'),
                          value: 'FUNDAMENTALCOMPLETO',
                        },
                        {
                          text: $t('Ensino_medio_incompleto'),
                          value: 'ENSMEDIOINCOMPLETO',
                        },
                        {
                          text: $t('Ensino_medio_completo'),
                          value: 'ENSMEDIOCOMPLETO',
                        },
                        {
                          text: $t('Ensino_superior_incompleto'),
                          value: 'SUPERIORINCOMPLETO',
                        },
                        {
                          text: $t('Ensino_superior_completo'),
                          value: 'SUPERIORCOMPLETO',
                        },
                        {
                          text: $t('Pos_graduado'),
                          value: 'POSGRADUADO',
                        },
                        { text: $t('Mestrado'), value: 'MESTRADO' },
                        { text: $t('Doutorado'), value: 'DOUTORADO' },
                      ]"
                      :label="$t('Instrucao')"
                      v-model="recurso.instrucao"
                      class="
                        input-style
                        font-size-input
                        text-light-input
                        placeholder-light
                        input-icon
                      "
                      dense
                      flat
                      filled
                      solo
                    ></v-select>
                  </v-col>

                  <v-col cols="12" md="4">
                    <span class="opacity-5 text-dark">
                      {{ $t("Raca") }}
                    </span>
                    <v-select
                      :items="[
                        { text: $t('Branca'), value: 'BRANCA' },
                        { text: $t('Preta'), value: 'PRETA' },
                        { text: $t('Parda'), value: 'PARDA' },
                        { text: $t('Amarela'), value: 'AMARELA' },
                        { text: $t('Indigena'), value: 'INDIGENA' },
                      ]"
                      :label="$t('Raca')"
                      v-model="recurso.raca"
                      class="
                        input-style
                        font-size-input
                        text-light-input
                        placeholder-light
                        input-icon
                      "
                      dense
                      flat
                      filled
                      solo
                    ></v-select>
                  </v-col>

                  <v-col cols="12" md="4">
                    <span class="opacity-5 text-dark">
                      {{ $t("Sexo") }}
                    </span>
                    <v-select
                      :items="[
                        { text: $t('Masculino'), value: 'MASCULINO' },
                        { text: $t('Feminino'), value: 'FEMININO' },
                        { text: $t('Não Binário'), value: 'NAO_BINARIO' },
                      ]"
                      :label="$t('Sexo')"
                      v-model="recurso.pessoa.sexo"
                      class="
                        input-style
                        font-size-input
                        text-light-input
                        placeholder-light
                        input-icon
                      "
                      dense
                      flat
                      filled
                      solo
                    ></v-select>
                  </v-col>

                  <v-col cols="12" md="4">
                    <span class="opacity-5 text-dark">
                      {{ $t("Naturalidade") }}
                    </span>
                    <CampoRelacionamentoCadastroRapido
                      v-model="recurso.naturalidade"
                      url="/cidades"
                      label="Naturalidade"
                      name="naturalidade"
                      :item-text="formatCidade"
                      :remote-search="true"
                      search-url="/cidades/search"
                      :min-search-length="2"
                      :remote-page-size="20"
                      remote-order-by="nome"
                      :remote-cache="cidadesSearchCache"
                    />
                  </v-col>

                  <v-col cols="12" md="4">
                    <span class="opacity-5 text-dark">
                      {{ $t("Estado_civil") }}
                    </span>
                    <v-autocomplete
                      :items="[
                        { text: $t('Solteiro'), value: 'SOLTEIRO' },
                        { text: $t('Casado'), value: 'CASADO' },
                        { text: $t('Divorciado'), value: 'DIVORCIADO' },
                        { text: $t('Separado'), value: 'SEPARADO' },
                        { text: $t('Viuvo'), value: 'VIUVO' },

                        { text: $t('Comcubinado'), value: 'COMCUBINADO' },
                        { text: $t('UniaoEstavel'), value: 'UNIAOESTAVEL' },
                      ]"
                      item-text="text"
                      item-value="value"
                      :label="$t('Estado_civil')"
                      v-model="recurso.estadoCivil"
                      class="
                        input-style
                        font-size-input
                        text-light-input
                        placeholder-light
                        input-icon
                      "
                      dense
                      flat
                      filled
                      solo
                    >
                    </v-autocomplete>
                  </v-col>

                  <v-col cols="12" md="6">
                    <span class="opacity-5 text-dark">
                      {{ $t("Grupo_sanguineo") }}
                    </span>
                    <v-select
                      :items="[
                        { text: $t('APOSITIVO'), value: 'APOSITIVO' },
                        { text: $t('ANEGATIVO'), value: 'ANEGATIVO' },
                        { text: $t('BPOSITIVO'), value: 'BPOSITIVO' },
                        { text: $t('BNEGATIVO'), value: 'BNEGATIVO' },
                        { text: $t('ABPOSITIVO'), value: 'ABPOSITIVO' },
                        { text: $t('ABNEGATIVO'), value: 'ABNEGATIVO' },
                        { text: $t('OPOSITIVO'), value: 'OPOSITIVO' },
                        { text: $t('ONEGATIVO'), value: 'ONEGATIVO' },
                      ]"
                      :label="$t('Grupo_sanguineo')"
                      v-model="recurso.grupoSanguineo"
                      class="
                        input-style
                        font-size-input
                        text-light-input
                        placeholder-light
                        input-icon
                      "
                      dense
                      flat
                      filled
                      solo
                    ></v-select>
                  </v-col>

                  <v-col cols="12" md="6">
                    <span class="opacity-5 text-dark">
                      {{ $t("Nome_da_mae") }}
                    </span>
                    <v-text-field
                      v-model="recurso.nomeMae"
                      :label="$t('Nome_da_mae')"
                      name="nomeMae"
                      class="
                        input-style
                        font-size-input
                        text-light-input
                        placeholder-light
                        input-icon
                      "
                      dense
                      flat
                      filled
                      solo
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" md="6">
                    <span class="opacity-5 text-dark">
                      {{ $t("Nome_do_pai") }}
                    </span>
                    <v-text-field
                      v-model="recurso.nomePai"
                      :label="$t('Nome_do_pai')"
                      name="nomePai"
                      class="
                        input-style
                        font-size-input
                        text-light-input
                        placeholder-light
                        input-icon
                      "
                      dense
                      flat
                      filled
                      solo
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" md="6">
                    <span class="opacity-5 text-dark">
                      {{ $t("Nome_do_conjuge") }}
                    </span>
                    <v-text-field
                      v-model="recurso.nomeConjuge"
                      :label="$t('Nome_do_conjuge')"
                      name="nomeConjuge"
                      class="
                        input-style
                        font-size-input
                        text-light-input
                        placeholder-light
                        input-icon
                      "
                      dense
                      flat
                      filled
                      solo
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" md="12">
                    <span class="opacity-5 text-dark">
                      {{ $t("Nome_social") }}
                    </span>
                    <v-text-field
                      v-model="recurso.nomeSocial"
                      :label="$t('Nome_social')"
                      name="nomeSocial"
                      class="
                        input-style
                        font-size-input
                        text-light-input
                        placeholder-light
                        input-icon
                      "
                      dense
                      flat
                      filled
                      solo
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel>
              <v-expansion-panel-header>{{
                this.$t("Informacoes_da_contratacao")
              }}</v-expansion-panel-header>

              <v-expansion-panel-content>
                <v-row>
                  <v-col cols="12" md="6">
                    <span class="opacity-5 text-dark">
                      {{ $t("Matricula") }}
                    </span>
                    <v-text-field
                      v-model="recurso.matricula"
                      :label="$t('Matricula')"
                      name="matricula"
                      class="
                        input-style
                        font-size-input
                        text-light-input
                        placeholder-light
                        input-icon
                      "
                      dense
                      flat
                      filled
                      solo
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="3">
                    <v-text-field
                      :value="recurso.matriculaEsocial"
                      label="Matrícula eSocial"
                      hint="Preenchida pela vinculação na importação do eSocial"
                      persistent-hint
                      readonly
                      outlined
                      dense
                    />
                  </v-col>
                  <v-col cols="12" md="6" id="admissao">
                    <span class="opacity-5 text-dark">
                      {{ $t("Data_de_admissao") }}
                    </span>
                    <CampoData
                      :payload="recurso.admissao"
                      @date="recurso.admissao = $event"
                      :label="$t('Data_de_admissao')"
                    />
                  </v-col>

                  <v-col cols="12" md="6">
                    <span class="opacity-5 text-dark">
                      {{ $t("Status") }}
                    </span>
                    <v-select
                      :items="[
                        { text: $t('Ativo'), value: 'ATIVO' },
                        { text: $t('Ferias'), value: 'FERIAS' },
                        { text: $t('Afastado'), value: 'AFASTADO' },
                        { text: $t('Desligado'), value: 'DESLIGADO' },
                      ]"
                      :label="$t('Status')"
                      v-model="recurso.status"
                      class="
                        input-style
                        font-size-input
                        text-light-input
                        placeholder-light
                        input-icon
                      "
                      dense
                      flat
                      filled
                      solo
                    ></v-select>
                  </v-col>
                  <v-col cols="12" md="6" v-if="recurso.status === 'DESLIGADO'">
                    <span class="opacity-5 text-dark">
                      {{ $t("Data_de_desligamento") }}
                    </span>
                    <CampoData
                      @date="recurso.dtDesligamento = $event"
                      :label="$t('Data_de_desligamento')"
                      :payload="recurso.dtDesligamento"
                      name="dtDesligamento"
                    />
                  </v-col>
                  <v-col cols="12" md="3">
                    <span class="opacity-5 text-dark">
                      {{ $t("Data_termino_do_contrato") }}
                    </span>
                    <CampoData
                      @date="recurso.terminoContrato = $event"
                      :label="$t('Data_termino_do_contrato')"
                      :payload="recurso.terminoContrato"
                    />
                  </v-col>

                  <v-col cols="12" md="3">
                    <span class="opacity-5 text-dark">
                      {{ $t("Tipo_de_contrato") }}
                    </span>
                    <v-select
                      :items="[
                        {
                          text: $t('Prazo_indeterminado'),
                          value: 'PRAZOINDETERMINADO',
                        },
                        {
                          text: $t('PRAZODETERMEMDIAS'),
                          value: 'PRAZODETERMEMDIAS',
                        },
                        {
                          text: $t('PRAZODETERMVINCAOCORRENCIA'),
                          value: 'PRAZODETERMVINCAOCORRENCIA',
                        },
                        {
                          text: $t('INTERMITENTE'),
                          value: 'INTERMITENTE',
                        },
                      ]"
                      :label="$t('Tipo_de_contrato')"
                      name="contratoTipo"
                      v-model="recurso.contratoTipo"
                      class="
                        input-style
                        font-size-input
                        text-light-input
                        placeholder-light
                        input-icon
                      "
                      dense
                      flat
                      filled
                      solo
                    ></v-select>
                  </v-col>

                  <v-col cols="12" md="3">
                    <v-checkbox v-model="recurso.primeiroEmprego">
                      <template v-slot:label>
                        <div>{{ $t("Primeiro_emprego") }}</div>
                      </template>
                    </v-checkbox>
                  </v-col>

                  <v-col cols="12" md="3">
                    <v-text-field-money
                      v-model="recurso.salarioBase"
                      v-bind:label="$t('Salario_base')"
                      v-bind:properties="{
                        prefix: 'R$',
                        readonly: false,
                        disabled: false,
                        outlined: false,
                        clearable: true,
                      }"
                      v-bind:options="{
                        locale: 'pt-BR',
                        length: 12,
                        precision: 2,
                        empty: '0',
                      }"
                      class="font-size-input text-light-input placeholder-light"
                      dense
                      flat
                      filled
                      solo
                    />
                    <v-btn
                      v-if="recurso.id"
                      text
                      small
                      color="#5e72e4"
                      class="px-0 text-none"
                      @click="abrirHistoricoSalarios"
                    >
                      <v-icon left small>mdi-history</v-icon>
                      {{ $t("Historico_de_salarios") }}
                    </v-btn>
                  </v-col>

                  <v-col v-if="salarioAlterado" cols="12" md="3">
                    <span class="opacity-5 text-dark">
                      {{ $t("Salario_a_partir_de") }}
                    </span>
                    <v-text-field
                      v-model="competenciaSalario"
                      type="month"
                      :min="mesAdmissao"
                      :max="mesAtual"
                      :label="$t('Salario_a_partir_de')"
                      name="salarioCompetencia"
                      :hint="$t('Salario_a_partir_de_dica')"
                      persistent-hint
                      class="
                        input-style
                        font-size-input
                        text-light-input
                        placeholder-light
                        input-icon
                      "
                      dense
                      flat
                      filled
                      solo
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" md="4">
                    <span class="opacity-5 text-dark">
                      {{ $t("Unidade_de_salario") }}
                    </span>
                    <v-select
                      :items="[
                        { text: $t('Por_hora'), value: 'PORHORA' },
                        { text: $t('Por_dia'), value: 'PORDIA' },
                        { text: $t('Por_semana'), value: 'PORSEMANA' },
                        { text: $t('Por_quinzena'), value: 'PORQUINZENA' },
                        { text: $t('Por_mes'), value: 'PORMES' },
                        { text: $t('Por_tarefa'), value: 'PORTAREFA' },
                        { text: $t('Variavel'), value: 'VARIAVEL' },
                      ]"
                      :label="$t('Unidade_de_salario')"
                      v-model="recurso.salarioUnidade"
                      class="
                        input-style
                        font-size-input
                        text-light-input
                        placeholder-light
                        input-icon
                      "
                      dense
                      flat
                      filled
                      solo
                    ></v-select>
                  </v-col>

                  <v-col cols="12" md="3">
                    <span class="opacity-5 text-dark">
                      {{ $t("Divisor_padrao_de_horas") }}
                    </span>
                    <v-text-field
                      v-model="recurso.divisorPadraoHoras"
                      type="number"
                      min="1"
                      max="744"
                      step="0.01"
                      suffix="h"
                      :label="$t('Divisor_padrao_de_horas')"
                      name="divisorPadraoHoras"
                      :hint="$t('Divisor_padrao_de_horas_dica')"
                      persistent-hint
                      class="
                        input-style
                        font-size-input
                        text-light-input
                        placeholder-light
                        input-icon
                      "
                      dense
                      flat
                      filled
                      solo
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" md="5">
                    <span class="opacity-5 text-dark">
                      {{ $t("Sindicato") }}
                    </span>
                    <v-autocomplete
                      disabled
                      :items="this.itensSindicato"
                      item-text="descricao"
                      return-object
                      :label="$t('Sindicato')"
                      v-model="recurso.sindicato"
                      class="
                        input-style
                        font-size-input
                        text-light-input
                        placeholder-light
                        input-icon
                      "
                      dense
                      flat
                      filled
                      solo
                    >
                    </v-autocomplete>
                  </v-col>

                  <!-- <v-col cols="12" md="6">
                  <v-select
                    :items="[
                      { text: $t('Ativo'), value: 0 },
                      { text: $t('Ferias'), value: 1 },
                      { text: $t('Afastado'), value: 2 },
                      { text: $t('Desligado'), value: 3 },
                    ]"
                    :label="$t('Status')"
                    v-model="recurso.status"
                  ></v-select>
                </v-col> -->

                  <!-- <v-col cols="12" md="6">
                  <v-select
                    :items="[
                      { text: $t('Ativo'), value: 'ATIVO' },
                      { text: $t('Ferias'), value: 'FERIAS' },
                      { text: $t('Afastado'), value: 'AFASTADO' },
                      { text: $t('Desligado'), value: 'DESLIGADO' },
                    ]"
                    :label="$t('Status')"
                    v-model="recurso.status"
                  ></v-select>
                </v-col> -->

                  <v-col cols="12" md="4">
                    <span class="opacity-5 text-dark">
                      {{ $t("Tipo_de_jornada") }}
                    </span>
                    <v-select
                      :items="[
                        { text: $t('SUBHRTRAB'), value: 'SUBHRTRAB' },
                        {
                          text: $t('ATIVIDADEEXTRA'),
                          value: 'ATIVIDADEEXTRA',
                        },
                        {
                          text: $t('FUNCOESESPEC'),
                          value: 'FUNCOESESPEC',
                        },
                        {
                          text: $t('TELETRABALHO'),
                          value: 'TELETRABALHO',
                        },
                      ]"
                      :label="$t('Tipo_de_jornada')"
                      v-model="recurso.tipoJornada"
                      class="
                        input-style
                        font-size-input
                        text-light-input
                        placeholder-light
                        input-icon
                      "
                      dense
                      flat
                      filled
                      solo
                    ></v-select>
                  </v-col>

                  <v-col cols="12" md="4">
                    <span class="opacity-5 text-dark">
                      {{ $t("Data_de_termino_experiencia") + " 1" }}
                    </span>
                    <CampoData
                      @date="recurso.experienciaTermino1 = $event"
                      :label="$t('Data_de_termino_experiencia') + ' 1'"
                      :payload="recurso.experienciaTermino1"
                      name="experienciaTermino1"
                    />
                  </v-col>

                  <v-col cols="12" md="4">
                    <span class="opacity-5 text-dark">
                      {{ $t("Data_de_termino_experiencia") + " 2" }}
                    </span>
                    <CampoData
                      @date="recurso.experienciaTermino2 = $event"
                      :label="$t('Data_de_termino_experiencia') + ' 2'"
                      :payload="recurso.experienciaTermino2"
                      name="experienciaTermino2"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    md="3"
                    v-if="
                      possuiParametrizacaoInquilino(
                        'INFORMACAORESUMIDAVALETRANSPORTECONTRATACAOFUNCIONARIO'
                      )
                    "
                  >
                    <v-checkbox v-model="recurso.optanteValeTransporte">
                      <template v-slot:label>
                        <p>{{ $t("OptanteValeTransporte") }}</p>
                      </template>
                    </v-checkbox>
                  </v-col>
                  <v-col cols="12" md="3" v-if="recurso.optanteValeTransporte">
                    <v-text-field-money
                      v-model="recurso.valorDiarioValeTransporte"
                      v-bind:label="$t('ValorDiarioValeTransporte')"
                      v-bind:properties="{
                        prefix: 'R$',
                        readonly: false,
                        disabled: false,
                        outlined: false,
                        clearable: true,
                      }"
                      v-bind:options="{
                        locale: 'pt-BR',
                        length: 12,
                        precision: 2,
                        empty: '0',
                      }"
                    />
                  </v-col>
                  <v-col cols="12" md="3" v-if="isOrgaoPublico">
                    <span class="opacity-5 text-dark">
                      {{ $t("Servidor_categoria") }}
                    </span>
                    <v-select
                      :items="itensServidorCategoria"
                      :label="$t('Servidor_categoria')"
                      v-model="recurso.servidorCategoria"
                      disabled
                      class="
                        input-style
                        font-size-input
                        text-light-input
                        placeholder-light
                        input-icon
                      "
                      dense
                      flat
                      filled
                      solo
                    ></v-select>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel>
              <v-expansion-panel-header>{{
                this.$t("Documentos")
              }}</v-expansion-panel-header>

              <v-expansion-panel-content>
                <v-row>
                  <v-col cols="12" md="6">
                    <span class="opacity-5 text-dark">
                      {{ $t("Numero_ctps") }}
                    </span>
                    <v-text-field
                      v-model="recurso.ctpsNumero"
                      :label="$t('Numero_ctps')"
                      name="ctpsNumero"
                      class="
                        input-style
                        font-size-input
                        text-light-input
                        placeholder-light
                        input-icon
                      "
                      dense
                      flat
                      filled
                      solo
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" md="6">
                    <span class="opacity-5 text-dark">
                      {{ $t("Serie_ctps") }}
                    </span>
                    <v-text-field
                      v-model="recurso.ctpsSerie"
                      :label="$t('Serie_ctps')"
                      name="ctpsSerie"
                      class="
                        input-style
                        font-size-input
                        text-light-input
                        placeholder-light
                        input-icon
                      "
                      dense
                      flat
                      filled
                      solo
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" md="6">
                    <v-checkbox v-model="recurso.fgtsOptante">
                      <template v-slot:label>
                        <div>{{ $t("Fgts_optante") }}</div>
                      </template>
                    </v-checkbox>
                  </v-col>

                  <v-col cols="12" md="6">
                    <v-checkbox v-model="recurso.inssOptante">
                      <template v-slot:label>
                        <div>{{ $t("Inss_optante") }}</div>
                      </template>
                    </v-checkbox>
                  </v-col>

                  <!-- <v-col cols="12" md="4">
                            <v-checkbox v-model="recurso.opcaoFGTS">
                              <template v-slot:label>
                                <div>{{ $t("Opcao_fgts") }}</div>
                              </template>
                            </v-checkbox>
                          </v-col> -->

                  <v-divider></v-divider>

                  <v-col cols="12" md="6">
                    <span class="opacity-5 text-dark">
                      {{ $t("Categoria_reservista") }}
                    </span>
                    <v-text-field
                      v-model="recurso.reservistaCategoria"
                      :label="$t('Categoria_reservista')"
                      name="reservistaCategoria"
                      class="
                        input-style
                        font-size-input
                        text-light-input
                        placeholder-light
                        input-icon
                      "
                      dense
                      flat
                      filled
                      solo
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" md="6">
                    <span class="opacity-5 text-dark">
                      {{ $t("Numero_reservista") }}
                    </span>
                    <v-text-field
                      v-model="recurso.reservistaNumero"
                      :label="$t('Numero_reservista')"
                      name="reservistaNumero"
                      class="
                        input-style
                        font-size-input
                        text-light-input
                        placeholder-light
                        input-icon
                      "
                      dense
                      flat
                      filled
                      solo
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" md="6">
                    <span class="opacity-5 text-dark">
                      {{ $t("CPF") }}
                    </span>
                    <v-text-field
                      v-model="recurso.pessoa.cpf"
                      :label="$t('CPF')"
                      name="cpf"
                      class="
                        input-style
                        font-size-input
                        text-light-input
                        placeholder-light
                        input-icon
                      "
                      dense
                      flat
                      filled
                      solo
                      v-mask="'###.###.###-##'"
                      mask-placeholder="_"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" md="6">
                    <span class="opacity-5 text-dark">
                      {{ $t("PIS") }}
                    </span>
                    <v-text-field
                      v-model="recurso.pis"
                      :label="$t('PIS')"
                      name="pis"
                      class="
                        input-style
                        font-size-input
                        text-light-input
                        placeholder-light
                        input-icon
                      "
                      dense
                      flat
                      filled
                      solo
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" md="4">
                    <span class="opacity-5 text-dark">
                      {{ $t("RG") }}
                    </span>
                    <v-text-field
                      v-model="recurso.rg"
                      :label="$t('RG')"
                      name="rg"
                      class="
                        input-style
                        font-size-input
                        text-light-input
                        placeholder-light
                        input-icon
                      "
                      dense
                      flat
                      filled
                      solo
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" md="4">
                    <span class="opacity-5 text-dark">
                      {{ $t("Expedicao_rg") }}
                    </span>
                    <CampoData
                      @date="recurso.rgExpedicao = $event"
                      :label="$t('Expedicao_rg')"
                      :payload="recurso.rgExpedicao"
                    />
                  </v-col>

                  <v-col cols="12" md="4">
                    <span class="opacity-5 text-dark">
                      {{ $t("Uf_expedicao_rg") }}
                    </span>
                    <v-autocomplete
                      :items="this.estados"
                      item-text="nome"
                      return-object
                      :label="$t('Uf_expedicao_rg')"
                      v-model="recurso.rgUF"
                      class="
                        input-style
                        font-size-input
                        text-light-input
                        placeholder-light
                        input-icon
                      "
                      dense
                      flat
                      filled
                      solo
                    >
                    </v-autocomplete>
                  </v-col>

                  <v-col cols="12" md="4">
                    <span class="opacity-5 text-dark">
                      {{ $t("CNH") }}
                    </span>
                    <v-text-field
                      v-model="recurso.cnh"
                      :label="$t('CNH')"
                      name="cnh"
                      class="
                        input-style
                        font-size-input
                        text-light-input
                        placeholder-light
                        input-icon
                      "
                      dense
                      flat
                      filled
                      solo
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" md="4">
                    <span class="opacity-5 text-dark">
                      {{ $t("Categoria_cnh") }}
                    </span>
                    <v-select
                      :items="[
                        { text: 'A', value: 'CNHA' },
                        { text: 'B', value: 'CNHB' },
                        { text: 'C', value: 'CNHC' },
                        { text: 'D', value: 'CNHD' },
                        { text: 'E', value: 'CNHE' },
                        { text: 'AB', value: 'CNHAB' },
                        { text: 'AC', value: 'CNHAC' },
                        { text: 'AD', value: 'CNHAD' },
                        { text: 'AE', value: 'CNHAE' },
                      ]"
                      :label="$t('Categoria_cnh')"
                      v-model="recurso.cnhCategoria"
                      class="
                        input-style
                        font-size-input
                        text-light-input
                        placeholder-light
                        input-icon
                      "
                      dense
                      flat
                      filled
                      solo
                    ></v-select>
                  </v-col>

                  <v-col cols="12" md="4">
                    <span class="opacity-5 text-dark">
                      {{ $t("Uf_cnh") }}
                    </span>
                    <v-autocomplete
                      :items="this.estados"
                      item-text="nome"
                      return-object
                      :label="$t('Uf_cnh')"
                      class="
                        input-style
                        font-size-input
                        text-light-input
                        placeholder-light
                        input-icon
                      "
                      dense
                      flat
                      filled
                      solo
                    >
                    </v-autocomplete>
                  </v-col>

                  <v-col cols="12" sm="6" md="6">
                    <span class="opacity-5 text-dark">
                      {{ $t("Cnh_validade") }}
                    </span>
                    <CampoData
                      @date="recurso.cnhValidade = $event"
                      :label="$t('Cnh_validade')"
                      :payload="recurso.cnhValidade"
                    />
                  </v-col>

                  <v-col cols="12" sm="6" md="6">
                    <span class="opacity-5 text-dark">
                      {{ $t("Cnh_emissao") }}
                    </span>
                    <CampoData
                      @date="recurso.cnhEmissao = $event"
                      :label="$t('Cnh_emissao')"
                      :payload="recurso.cnhEmissao"
                    />
                  </v-col>

                  <v-col cols="12" sm="3" md="3">
                    <v-text-field
                      v-model="recurso.tituloEleitoral"
                      :label="$t('tituloEleitoral')"
                      :payload="recurso.tituloEleitoral"
                    />
                  </v-col>

                  <v-col cols="12" sm="3" md="3">
                    <v-text-field
                      v-model="recurso.tituloEleitoralZona"
                      :label="$t('tituloEleitoralZona')"
                      :payload="recurso.tituloEleitoralZona"
                    />
                  </v-col>
                  <v-col cols="12" sm="3" md="3">
                    <v-text-field
                      v-model="recurso.tituloEleitoralSecao"
                      :label="$t('tituloEleitoralSecao')"
                      :payload="recurso.tituloEleitoralSecao"
                    />
                  </v-col>
                  <v-col cols="12" sm="6" md="3">
                    <v-text-field
                      v-model="recurso.cnv"
                      label="CNV"
                      name="cnv"
                    />
                  </v-col>
                  <v-col cols="12" sm="6" md="3">
                    <span class="opacity-5 text-dark">
                      {{ $t("cnv_validade") }}
                    </span>
                    <CampoData
                      @date="recurso.cnvValidade = $event"
                      label="cnv_validade"
                      :payload="recurso.cnvValidade"
                    />
                  </v-col>
                  <v-col cols="12" sm="6" md="3">
                    <span class="opacity-5 text-dark">
                      {{ $t("vencimento_seguanca_pessoal") }}
                    </span>
                    <CampoData
                      @date="recurso.vencimentoSeguancaPessoal = $event"
                      label="vencimento_seguanca_pessoal"
                      :payload="recurso.vencimentoSeguancaPessoal"
                    />
                  </v-col>

                  <v-col cols="12" sm="6" md="3">
                    <span class="opacity-5 text-dark">
                      {{ $t("vencimento_seguranca_patrimonial") }}
                    </span>
                    <CampoData
                      @date="recurso.vencimentoSegurancaPatrimonial = $event"
                      label="vencimento_seguranca_patrimonial"
                      :payload="recurso.vencimentoSegurancaPatrimonial"
                    />
                  </v-col>

                  <v-col cols="12" sm="6" md="3">
                    <span class="opacity-5 text-dark">
                      {{ $t("vencimento_seguranca_transporte_valores") }}
                    </span>
                    <CampoData
                      @date="
                        recurso.vencimentoSegurancaTransporteValores = $event
                      "
                      label="vencimento_seguranca_transporte_valores"
                      :payload="recurso.vencimentoSegurancaTransporteValores"
                    />
                  </v-col>

                  <v-col cols="12" sm="6" md="3">
                    <span class="opacity-5 text-dark">
                      {{ $t("vencimento_pscicotecnico") }}
                    </span>
                    <CampoData
                      @date="recurso.vencimentoPscicotecnico = $event"
                      label="vencimento_pscicotecnico"
                      :payload="recurso.vencimentoPscicotecnico"
                    />
                  </v-col>
                  <v-col cols="12" sm="6" md="3">
                    <span class="opacity-5 text-dark">
                      {{ $t("vencimento_toxicologico") }}
                    </span>
                    <CampoData
                      @date="recurso.vencimentoToxicologico = $event"
                      label="vencimento_toxicologico"
                      :payload="recurso.vencimentoToxicologico"
                    />
                  </v-col>
                  <v-col v-if="isOrgaoPublico" cols="12" md="6">
                    <span class="opacity-5 text-dark">CRM</span>
                    <v-text-field
                      v-model="recurso.crm"
                      label="CRM"
                      name="crm"
                      class="
                        input-style
                        font-size-input
                        text-light-input
                        placeholder-light
                        input-icon
                      "
                      dense
                      flat
                      filled
                      solo
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel>
              <v-expansion-panel-header>{{
                this.$t("Endereco")
              }}</v-expansion-panel-header>

              <v-expansion-panel-content>
                <v-row>
                  <v-col cols="12" md="4">
                    <span class="opacity-5 text-dark">
                      {{ $t("Cidade") }}
                    </span>
                    <CampoRelacionamentoCadastroRapido
                      v-model="recurso.pessoa.cidade"
                      url="/cidades"
                      label="Cidade"
                      name="cidade"
                      :item-text="formatCidade"
                      :remote-search="true"
                      search-url="/cidades/search"
                      :min-search-length="2"
                      :remote-page-size="20"
                      remote-order-by="nome"
                      :remote-cache="cidadesSearchCache"
                    />
                  </v-col>

                  <v-col cols="12" md="4">
                    <span class="opacity-5 text-dark">
                      {{ $t("CEP") }}
                    </span>
                    <v-text-field
                      v-model="recurso.pessoa.cep"
                      :label="$t('CEP')"
                      v-mask="'##.###-###'"
                      @blur="buscaCep($event)"
                      class="
                        input-style
                        font-size-input
                        text-light-input
                        placeholder-light
                        input-icon
                      "
                      dense
                      flat
                      filled
                      solo
                    />
                  </v-col>

                  <v-col cols="12" md="4">
                    <span class="opacity-5 text-dark">
                      {{ $t("Descricao") }}
                    </span>
                    <v-text-field
                      v-model="recurso.pessoa.descricao"
                      :label="$t('Descricao')"
                      name="descricao"
                      class="
                        input-style
                        font-size-input
                        text-light-input
                        placeholder-light
                        input-icon
                      "
                      dense
                      flat
                      filled
                      solo
                    />
                  </v-col>

                  <v-col cols="12">
                    <span class="opacity-5 text-dark">
                      {{ $t("Logradouro") }}
                    </span>
                    <v-text-field
                      v-model="recurso.pessoa.logradouro"
                      :label="$t('Logradouro')"
                      name="logradouro"
                      class="
                        input-style
                        font-size-input
                        text-light-input
                        placeholder-light
                        input-icon
                      "
                      dense
                      flat
                      filled
                      solo
                    >
                    </v-text-field>
                  </v-col>

                  <v-col cols="12" md="6">
                    <span class="opacity-5 text-dark">
                      {{ $t("Numero") }}
                    </span>
                    <v-text-field
                      v-model="recurso.pessoa.numero"
                      :label="$t('Numero')"
                      name="numero"
                      type="number"
                      class="
                        input-style
                        font-size-input
                        text-light-input
                        placeholder-light
                        input-icon
                      "
                      dense
                      flat
                      filled
                      solo
                    >
                    </v-text-field>
                  </v-col>

                  <v-col cols="12" md="6">
                    <span class="opacity-5 text-dark">
                      {{ $t("Complemento") }}
                    </span>
                    <v-text-field
                      v-model="recurso.pessoa.complementoEndereco"
                      :label="$t('Complemento')"
                      name="complemento"
                      class="
                        input-style
                        font-size-input
                        text-light-input
                        placeholder-light
                        input-icon
                      "
                      dense
                      flat
                      filled
                      solo
                    />
                  </v-col>

                  <v-col cols="12" md="12">
                    <span class="opacity-5 text-dark">
                      {{ $t("Bairro") }}
                    </span>
                    <v-text-field
                      v-model="recurso.pessoa.bairro"
                      :label="$t('Bairro')"
                      name="bairro"
                      class="
                        input-style
                        font-size-input
                        text-light-input
                        placeholder-light
                        input-icon
                      "
                      dense
                      flat
                      filled
                      solo
                    />
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel>
              <v-expansion-panel-header>{{
                this.$t("Dados_bancarios")
              }}</v-expansion-panel-header>

              <v-expansion-panel-content>
                <v-row>
                  <v-col cols="12" md="6">
                    <span class="opacity-5 text-dark">
                      {{ $t("Agencia_numero") }}
                    </span>
                    <v-text-field
                      v-model="recurso.contaAgencia"
                      :label="$t('Agencia_numero')"
                      name="agenciaNumero"
                      class="
                        input-style
                        font-size-input
                        text-light-input
                        placeholder-light
                        input-icon
                      "
                      dense
                      flat
                      filled
                      solo
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" md="6">
                    <span class="opacity-5 text-dark">
                      {{ $t("Banco") }}
                    </span>
                    <v-text-field
                      v-model="recurso.contaBanco"
                      :label="$t('Banco')"
                      name="contaBanco"
                      class="
                        input-style
                        font-size-input
                        text-light-input
                        placeholder-light
                        input-icon
                      "
                      dense
                      flat
                      filled
                      solo
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" md="6">
                    <span class="opacity-5 text-dark">
                      {{ $t("Conta_numero") }}
                    </span>
                    <v-text-field
                      v-model="recurso.contaNumero"
                      :label="$t('Conta_numero')"
                      name="contaNumero"
                      class="
                        input-style
                        font-size-input
                        text-light-input
                        placeholder-light
                        input-icon
                      "
                      dense
                      flat
                      filled
                      solo
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" md="6">
                    <span class="opacity-5 text-dark">
                      {{ $t("Conta_operacao") }}
                    </span>
                    <v-text-field
                      v-model="recurso.contaOperacao"
                      :label="$t('Conta_operacao')"
                      name="contaOperacao"
                      class="
                        input-style
                        font-size-input
                        text-light-input
                        placeholder-light
                        input-icon
                      "
                      dense
                      flat
                      filled
                      solo
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" md="6">
                    <span class="opacity-5 text-dark">
                      {{ $t("ChavePix") }}
                    </span>
                    <v-text-field
                      v-model="recurso.chavePix"
                      :label="$t('ChavePix')"
                      :hint="$t('Chave_pix_dica')"
                      persistent-hint
                      name="chavePix"
                      maxlength="77"
                      class="
                        input-style
                        font-size-input
                        text-light-input
                        placeholder-light
                        input-icon
                      "
                      dense
                      flat
                      filled
                      solo
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel>
              <v-expansion-panel-header>{{
                this.$t("Deficiencias")
              }}</v-expansion-panel-header>

              <v-expansion-panel-content>
                <v-row>
                  <v-col cols="12" md="4">
                    <v-checkbox v-model="recurso.cotaDeficiencia">
                      <template v-slot:label>
                        <div>{{ $t("Cota_deficiencia") }}</div>
                      </template>
                    </v-checkbox>
                  </v-col>

                  <v-col cols="12" md="4">
                    <v-checkbox v-model="recurso.defFisica">
                      <template v-slot:label>
                        <div>{{ $t("Deficiencia_fisica") }}</div>
                      </template>
                    </v-checkbox>
                  </v-col>

                  <v-col cols="12" md="4">
                    <v-checkbox v-model="recurso.defIntelectual">
                      <template v-slot:label>
                        <div>{{ $t("Deficiencia_intelectual") }}</div>
                      </template>
                    </v-checkbox>
                  </v-col>

                  <v-col cols="12" md="4">
                    <v-checkbox v-model="recurso.defMental">
                      <template v-slot:label>
                        <div>{{ $t("Deficiencia_mental") }}</div>
                      </template>
                    </v-checkbox>
                  </v-col>

                  <v-col cols="12" md="4">
                    <v-checkbox v-model="recurso.defAuditiva">
                      <template v-slot:label>
                        <div>{{ $t("Deficiencia_auditiva") }}</div>
                      </template>
                    </v-checkbox>
                  </v-col>

                  <v-col cols="12" md="4">
                    <v-checkbox v-model="recurso.defVisual">
                      <template v-slot:label>
                        <div>{{ $t("Deficiencia_visual") }}</div>
                      </template>
                    </v-checkbox>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel>
              <v-expansion-panel-header>{{
                this.$t("Dependentes")
              }}</v-expansion-panel-header>

              <v-expansion-panel-content>
                <v-col cols="12">
                  <CriaSuperSet
                    :podeEditarRecursoFinal="true"
                    :podeExcluirRecursoFinal="true"
                    @recursos="recurso.dependentes = $event"
                    :usaRecursoBase="false"
                    :payload="recurso.dependentes"
                    :pesquisa="false"
                    textoBotaoCadastro="Novo_registro"
                    tituloFinais="Dependentes"
                    subtituloFinais="Clique_para_adicionar"
                    :headersFinais="[
                      {
                        text: this.$t('Nome'),
                        value: 'nome',
                        sortable: 'true',
                      },
                      {
                        text: this.$t('Nascimento'),
                        value: 'nascimento',
                        sortable: 'true',
                      },

                      {
                        text: this.$t('Tipo'),
                        value: 'tipo',
                        sortable: 'true',
                      },
                      {
                        text: this.$t('CPF'),
                        value: 'cpf',
                        sortable: 'true',
                      },

                      {
                        text: this.$t('Acoes'),
                        value: 'actions',
                        sortable: 'false',
                      },
                    ]"
                  >
                    <template v-slot:default="slotProps">
                      <v-col cols="12" md="12">
                        <v-text-field
                          :rules="rule_required"
                          v-model="slotProps.recursoFinalAtual.nome"
                          :label="$t('Nome')"
                          name="nome"
                          type="text"
                          class="
                            input-style
                            font-size-input
                            text-light-input
                            placeholder-light
                            input-icon
                          "
                          dense
                          flat
                          filled
                          solo
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols="8" md="8">
                        <v-select
                          v-model="slotProps.recursoFinalAtual.tipo"
                          :items="itensTipoDependente"
                          :label="$t('Tipo')"
                          class="
                            input-style
                            font-size-input
                            text-light-input
                            placeholder-light
                            input-icon
                          "
                          dense
                          flat
                          filled
                          solo
                        ></v-select>
                      </v-col>
                      <v-col cols="12" sm="4" md="4">
                        <CampoData
                          @date="
                            slotProps.recursoFinalAtual.nascimento = $event
                          "
                          :label="$t('Data_de_nascimento')"
                        />
                      </v-col>
                      <v-col cols="12" md="4" sm="4">
                        <v-select
                          :items="[
                            { text: $t('Masculino'), value: 'MASCULINO' },
                            { text: $t('Feminino'), value: 'FEMININO' },
                            { text: $t('Não Binário'), value: 'NAO_BINARIO' },
                          ]"
                          :label="$t('Sexo')"
                          v-model="slotProps.recursoFinalAtual.sexo"
                          class="
                            input-style
                            font-size-input
                            text-light-input
                            placeholder-light
                            input-icon
                          "
                          dense
                          flat
                          filled
                          solo
                        ></v-select>
                      </v-col>
                      <v-col cols="4" md="4">
                        <v-text-field
                          :rules="rule_required"
                          v-model="slotProps.recursoFinalAtual.cpf"
                          :label="$t('CPF')"
                          name="cpf"
                          type="text"
                          class="
                            input-style
                            font-size-input
                            text-light-input
                            placeholder-light
                            input-icon
                          "
                          dense
                          flat
                          filled
                          solo
                          v-mask="'###.###.###-##'"
                          mask-placeholder="_"
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" md="4" sm="4">
                        <v-checkbox
                          id="dependenteIrrf"
                          v-model="slotProps.recursoFinalAtual.dependenteIrrf"
                        >
                          <template v-slot:label>
                            {{ $t("dependenteIrrf") }}
                          </template>
                        </v-checkbox>
                      </v-col>
                      <v-col cols="12" md="4" sm="4">
                        <v-checkbox
                          id="dependenteSalarioFamilia"
                          v-model="
                            slotProps.recursoFinalAtual.dependenteSalarioFamilia
                          "
                        >
                          <template v-slot:label>
                            {{ $t("dependenteSalarioFamilia") }}
                          </template>
                        </v-checkbox>
                      </v-col>
                      <v-col cols="12" md="4" sm="4">
                        <v-checkbox
                          id="possuiIncapacidadeFisica"
                          v-model="
                            slotProps.recursoFinalAtual.possuiIncapacidadeFisica
                          "
                        >
                          <template v-slot:label>
                            {{ $t("possuiIncapacidadeFisica") }}
                          </template>
                        </v-checkbox>
                      </v-col>
                    </template>
                    <template v-slot:formEditaRecursoFinal="slotProps">
                      <v-col cols="12" md="12">
                        <span class="opacity-5 text-dark">
                          {{ $t("Nome") }}
                        </span>
                        <v-text-field
                          :rules="rule_required"
                          v-model="slotProps.recursoFinalAtual.nome"
                          :label="$t('Nome')"
                          name="nome"
                          type="text"
                          class="
                            input-style
                            font-size-input
                            text-light-input
                            placeholder-light
                            input-icon
                          "
                          dense
                          flat
                          filled
                          solo
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols="8" md="8">
                        <span class="opacity-5 text-dark">
                          {{ $t("Tipo") }}
                        </span>
                        <v-select
                          v-model="slotProps.recursoFinalAtual.tipo"
                          :items="itensTipoDependente"
                          :label="$t('Tipo')"
                          class="
                            input-style
                            font-size-input
                            text-light-input
                            placeholder-light
                            input-icon
                          "
                          dense
                          flat
                          filled
                          solo
                        ></v-select>
                      </v-col>
                      <v-col cols="12" sm="4" md="4">
                        <span class="opacity-5 text-dark">
                          {{ $t("Data_de_nascimento") }}
                        </span>
                        <CampoData
                          @date="
                            slotProps.recursoFinalAtual.nascimento = $event
                          "
                          :payload="slotProps.recursoFinalAtual.nascimento"
                          :label="$t('Data_de_nascimento')"
                        />
                      </v-col>
                      <v-col cols="12" md="4" sm="4">
                        <span class="opacity-5 text-dark">
                          {{ $t("Sexo") }}
                        </span>
                        <v-select
                          :items="[
                            { text: $t('Masculino'), value: 'MASCULINO' },
                            { text: $t('Feminino'), value: 'FEMININO' },
                            { text: $t('Não Binário'), value: 'NAO_BINARIO' },
                          ]"
                          :label="$t('Sexo')"
                          v-model="slotProps.recursoFinalAtual.sexo"
                          class="
                            input-style
                            font-size-input
                            text-light-input
                            placeholder-light
                            input-icon
                          "
                          dense
                          flat
                          filled
                          solo
                        ></v-select>
                      </v-col>
                      <v-col cols="4" md="4">
                        <span class="opacity-5 text-dark">
                          {{ $t("CPF") }}
                        </span>
                        <v-text-field
                          :rules="rule_required"
                          v-model="slotProps.recursoFinalAtual.cpf"
                          :label="$t('CPF')"
                          name="cpf"
                          type="text"
                          class="
                            input-style
                            font-size-input
                            text-light-input
                            placeholder-light
                            input-icon
                          "
                          dense
                          flat
                          filled
                          solo
                          v-mask="'###.###.###-##'"
                          mask-placeholder="_"
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" md="4" sm="4">
                        <v-checkbox
                          id="dependenteIrrf"
                          v-model="slotProps.recursoFinalAtual.dependenteIrrf"
                        >
                          <template v-slot:label>
                            {{ $t("dependenteIrrf") }}
                          </template>
                        </v-checkbox>
                      </v-col>
                      <v-col cols="12" md="4" sm="4">
                        <v-checkbox
                          id="dependenteSalarioFamilia"
                          v-model="
                            slotProps.recursoFinalAtual.dependenteSalarioFamilia
                          "
                        >
                          <template v-slot:label>
                            {{ $t("dependenteSalarioFamilia") }}
                          </template>
                        </v-checkbox>
                      </v-col>
                      <v-col cols="12" md="4" sm="4">
                        <v-checkbox
                          id="possuiIncapacidadeFisica"
                          v-model="
                            slotProps.recursoFinalAtual.possuiIncapacidadeFisica
                          "
                        >
                          <template v-slot:label>
                            {{ $t("possuiIncapacidadeFisica") }}
                          </template>
                        </v-checkbox>
                      </v-col>
                    </template>
                  </CriaSuperSet>
                </v-col>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel>
              <v-expansion-panel-header>{{
                this.$t("Informacoes_adicionais")
              }}</v-expansion-panel-header>

              <v-expansion-panel-content>
                <v-row>
                  <v-btn
                    :loading="loading"
                    @click="showBeneficiosOptante(recurso)"
                    v-can="'ROLE_BeneficioConvenioOptante_List'"
                    class="
                      ma-1
                      font-weight-bold
                      text-none
                      btn-primary
                      bg-gradient-primary
                      py-3
                      px-6
                      ms-3
                    "
                    height="39"
                  >
                    <v-icon left dark> mdi-shopping-search-outline </v-icon>
                    {{ $t("Listagem_de_beneficioconvenios") }}
                  </v-btn>

                  <v-btn
                    :loading="loading"
                    @click="showHistoricoBeneficios(recurso)"
                    v-can="'ROLE_BeneficioApuracao_List'"
                    class="
                      ma-1
                      font-weight-bold
                      text-none
                      btn-primary
                      bg-gradient-primary
                      py-3
                      px-6
                      ms-3
                    "
                    height="39"
                  >
                    <v-icon left dark> mdi-shopping-search-outline </v-icon>
                    {{ $t("Beneficio_apuracao") }}
                  </v-btn>
                  <v-btn
                    :loading="loading"
                    @click="showHistoricoSaldobancohoras(recurso)"
                    v-can="'ROLE_HistoricoSaldoBancoHoras_List'"
                    class="
                      ma-1
                      font-weight-bold
                      text-none
                      btn-primary
                      bg-gradient-primary
                      py-3
                      px-6
                      ms-3
                    "
                    height="39"
                  >
                    <v-icon left dark> mdi-shopping-search-outline </v-icon>
                    {{ $t("Saldo Banco de Horas") }}
                  </v-btn>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <v-textarea
                      v-model="recurso.observacao"
                      :label="$t('Observacao')"
                      name="observacao"
                      class="
                        input-style
                        font-size-input
                        text-light-input
                        placeholder-light
                        input-icon
                      "
                      dense
                      flat
                      filled
                      solo
                    ></v-textarea>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="12">
                    <span class="opacity-5 text-dark">
                      {{ $t("AlertaApuracaoPonto") }}
                    </span>
                    <v-text-field
                      v-model="recurso.alertaApuracaoPonto"
                      :label="$t('AlertaApuracaoPonto')"
                      name="alertaApuracaoPonto"
                      class="
                        input-style
                        font-size-input
                        text-light-input
                        placeholder-light
                        input-icon
                      "
                      dense
                      flat
                      filled
                      solo
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
              <v-expansion-panel-header>{{
                this.$t("Anexos")
              }}</v-expansion-panel-header>

              <v-expansion-panel-content>
                <v-row>
                  <v-btn
                    :loading="loading"
                    @click="showDocumentacaoAcessoria(recurso)"
                    v-can="'ROLE_FuncionarioDocumentacaoAcessoria_List'"
                    class="
                      ma-1
                      font-weight-bold
                      text-none
                      btn-primary
                      bg-gradient-primary
                      py-3
                      px-6
                      ms-3
                    "
                    height="39"
                  >
                    <v-icon left dark> mdi-text-box-search-outline </v-icon>
                    {{ $t("documentacaoacessoria") }}
                  </v-btn>

                  <v-btn
                    :loading="loading"
                    @click="showGed(recurso)"
                    v-can="'ROLE_FuncionarioGed_List'"
                    class="
                      ma-1
                      font-weight-bold
                      text-none
                      btn-primary
                      bg-gradient-primary
                      py-3
                      px-6
                      ms-3
                    "
                    height="39"
                    v-if="possuiGed()"
                  >
                    <v-icon left dark> mdi-paperclip </v-icon>
                    {{ $t("GED") }}
                  </v-btn>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <ComplementoEsocialFuncionario
              v-if="envioEsocialAtivo"
              :funcionario-id="recurso.id"
            />

            <v-expansion-panel v-if="calculoFolhaContratado && recurso.id">
              <v-expansion-panel-header>
                <span>
                  <v-icon left small>mdi-bank-transfer-out</v-icon>
                  Retenção do INSS (cálculo da folha)
                </span>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <RetencaoInssFuncionario :funcionario-id="recurso.id" />
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-row>
      </v-col>
    </EditarBase>
  </div>
</template>

<script>
import EditarBase from "@/components/base/Crud/EditarBase";
import CriaSuperSet from "@/components/base/proprios/CriaSuperset.vue";
import TabelaSelecionaRecurso from "@/components/base/proprios/TabelaSelecionaRecurso";
import ComumDataService from "@/services/ComumDataService";
import FuncionarioDataService from "@/services/pessoal/FuncionarioDataService";
import FuncionarioGedDataService from "@/services/pessoal/FuncionarioGedDataService";
import FuncionarioGedHistorico from "./FuncionarioGedHistorico.vue";
import ComplementoEsocialFuncionario from "@/components/pessoal/esocial-envio/ComplementoEsocialFuncionario.vue";
import envioAtivo from "@/components/pessoal/esocial-envio/envioAtivo";
import RetencaoInssFuncionario from "@/components/pessoal/folha-calculo/RetencaoInssFuncionario.vue";
import moduloCalculoFolha from "@/components/pessoal/folha-calculo/moduloCalculoFolha";
import cidadesBuscaRemota from "@/mixins/cidadesBuscaRemota";
import CampoRelacionamentoCadastroRapido from "@/components/base/proprios/CampoRelacionamentoCadastroRapido";
const DataService = FuncionarioDataService;

function mesCorrente() {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
}

// Valor do campo monetário ("1500.00", número ou vazio) em reais, para comparar com o carregado.
function numeroSalario(valor) {
  if (valor === null || valor === undefined || valor === "") return null;
  const n = Number(String(valor).replace(",", "."));
  return Number.isNaN(n) ? null : Math.round(n * 100) / 100;
}
export default {
  props: {
    itemAtual: { type: Object, required: false, default: null },
    recursoInicial: { type: Object, required: false, default: null },
  },
  name: "EditarFuncionario",
  components: {
    EditarBase,
    CampoRelacionamentoCadastroRapido,
    TabelaSelecionaRecurso,

    CriaSuperSet,
    FuncionarioGedHistorico,
    ComplementoEsocialFuncionario,
    RetencaoInssFuncionario,
  },
  mixins: [envioAtivo, moduloCalculoFolha, cidadesBuscaRemota],
  data() {
    return {
      DataService: DataService,

      submited: false,
      matriculaAutomatica: false,
      foneCount: 1,

      //Modais
      modalAdmissao: false,
      modalCnhValidade: false,
      modalCnhEmissao: false,
      modalTerminoContrato: false,
      modalExperienciaTermino1: false,
      modalExperienciaTermino2: false,
      modalRgExpedicao: false,
      modalDtNascimento: false,
      modalGed: false,
      modalHistoricoGed: false,
      gedSelecionado: null,
      mostrarArquivadosGed: false,
      gedArquivados: [],
      modalNewDocGed: false,

      newDocGed: {
        showModal: false,
        descricao: "",
        dataMinimaArmazenamentoFisico: null,
        matricula: "",
        file: null,
      },
      loading: false,
      //Tabelas
      estados: [],

      itensSindicato: [],
      modalHistoricoBeneficios: false,
      modalHistoricoSaldoBancoHoras: false,
      // Histórico de salários: o salário carregado identifica a alteração, que vale a partir da competência escolhida.
      salarioOriginal: null,
      salarioUnidadeOriginal: null,
      competenciaSalario: mesCorrente(),
      modalHistoricoSalarios: false,
      carregandoHistoricoSalarios: false,
      historicoSalarios: [],
      modalDocumentacaoAcessoria: false,

      headerHistoricoSaldoBancoHoras: [
        {
          text: this.$t("Inicio Periodo "),
          value: "periodo.inicioPeriodo",
          sortable: "false",
        },
        {
          text: this.$t("Fim Periodo"),
          value: "periodo.finalPeriodo",
          sortable: "false",
        },
        {
          text: this.$t("Movimentacao Banco Horas "),
          value: "movimentacaoBancoHorasPeriodo",
          sortable: "false",
        },
        {
          text: this.$t("Total"),
          value: "saldoBancoHoras",
          sortable: "false",
        },
      ],
      headerHistoricoBeneficios: [
        {
          text: this.$t("Matricula"),
          value: "funcionario.matricula",
          sortable: "false",
        },
        {
          text: this.$t(this.isOrgaoPublico ? "Servidor" : "Funcionario"),
          value: "funcionario.nomeSocial",
          sortable: "false",
        },
        {
          text: this.$t("Periodo"),
          value: "beneficioPeriodoApuracao.inicioPeriodo",
          sortable: "false",
        },
        {
          text: this.$t("Periodo"),
          value: "beneficioPeriodoApuracao.finalPeriodo",
          sortable: "false",
        },
        {
          text: this.$t("VA"),
          value: "vaTotal",
          sortable: "false",
        },
        {
          text: this.$t("VR"),
          value: "vrTotal",
          sortable: "false",
        },
        {
          text: this.$t("VT"),
          value: "vtTotal",
          sortable: "false",
        },
        {
          text: this.$t("Outros"),
          value: "outrosTotal",
          sortable: "false",
        },
        {
          text: this.$t("Total"),
          value: "valorTotal",
          sortable: "false",
        },
      ],
      listagemHistoricoBeneficios: [],
      listagemHistoricoSaldobancohoras: [],

      modalBeneficiosOptante: false,
      headerBeneficiosOptante: [
        {
          text: this.$t("Convenio"),
          value: "beneficioConvenio.descricao",
          sortable: "false",
        },
        {
          text: this.$t("quantidadePorApuracao"),
          value: "quantidadePorApuracao",
          sortable: "false",
        },
        {
          text: this.$t("Tipo"),
          value: "beneficioConvenio.tipo",
          sortable: "false",
        },
        {
          text: this.$t("Valor_unitario"),
          value: "beneficioConvenio.valorUnitario",
          sortable: "false",
        },
        {
          text: this.$t("Inicio"),
          value: "inicio",
          sortable: "false",
        },
        {
          text: this.$t("Encerramento"),
          value: "encerramento",
          sortable: "false",
        },
      ],
      listagemBeneficiosOptante: [],

      headerDocumentacaoAcessoria: [
        {
          text: this.$t("Nome"),
          value: "funcionario.nomeSocial",
          sortable: "false",
        },

        {
          text: this.$t("Data"),
          value: "dtInclusao",
          sortable: "false",
        },

        {
          text: this.$t("Descricao"),
          value: "descricao",
          sortable: "false",
        },
        {
          text: this.$t("Assinado"),
          value: "assinado",
          sortable: "false",
        },
        { text: this.$t("Acoes"), value: "actions", sortable: false },
      ],

      headerGed: [
        {
          text: this.$t("Descricao"),
          value: "descricao",
          sortable: "false",
        },
        {
          text: this.$t("Data_de_inclusao"),
          value: "dtInclusao",
          sortable: "false",
        },
        { text: this.$t("ged_arquivo"), value: "nomeArquivo", sortable: false },
        { text: this.$t("Acoes"), value: "actions", sortable: false },
      ],
      listagemDocumentacaoAcessoria: [],
      documentacaoAcessoriaSelecionada: [],
      listagemGed: [],

      recurso: {
        observacao: "",
        //Informações da contratação
        admissao: "",
        cargo: { salarioBase: "", descricao: "" },
        contratoTermino: "",
        contratoTipo: 0,
        servidorCategoria: null,
        primeiroEmprego: false,

        //salarioBase: "",
        salarioUnidade: null,
        divisorPadraoHoras: 220,
        sindicato: {},
        status: null,
        tipoAdmissao: null,
        tipoJornada: null,
        experienciaTermino1: "",
        experienciaTermino2: "",
        matricula: "",

        dtAlteracao: "", // Devo mandar ?
        dtInclusao: "", //

        //Documentos
        cnv: "",
        ctpsNumero: "",
        ctpsSerie: "",
        ctpsUF: "",
        fgtsOptante: false,
        inssOptante: false,
        opcaoFGTS: false,
        reservistaCategoria: "",
        reservistaNumero: "",
        cnh: "",
        cnhCategoria: 0,
        cnhUF: {},
        cnhValidade: "",
        cnhEmissao: "",
        rg: "",
        crm: "",
        rgExpedicao: "",
        rgUF: {},

        //Dados pessoais
        nome: "",
        email: "",
        raca: "",
        sexo: "",
        dtNascimento: "",
        instrucao: "",
        naturalidade: {},
        estadoCivil: "",
        grupoSanguineo: "",
        nomeMae: "",
        nomePai: "",
        nomeConjuge: "",
        nomeSocial: "",
        //Endereco
        pessoa: { cidade: {}, bairro: "", logradouro: "", telefones: [] },

        //Informações bancárias
        contaAgencia: "",
        contaBanco: "",
        contaNumero: "",
        contaOperacao: "",
        chavePix: "",

        //Deficiencias
        cotaDeficiencia: false,
        defFisica: false,
        defIntelectual: false,
        defMental: false,
        defAuditiva: false,
        defVisual: false,
      },
      pessoas: [],
      pessoa: {},

      errors: [],

      itensTipoDependente: [
        { text: this.$t("CONJUGUE"), value: "CONJUGUE" },
        {
          text: this.$t("COMPANHEIROUNIAOESTAVEL"),
          value: "COMPANHEIROUNIAOESTAVEL",
        },

        { text: this.$t("FILHOENTEADO"), value: "FILHOENTEADO" },
        {
          text: this.$t("IRMAONETOBISNETOSEMARRIMO"),
          value: "IRMAONETOBISNETOSEMARRIMO",
        },
        { text: this.$t("PAISAVOSBISAVOS"), value: "PAISAVOSBISAVOS" },
        { text: this.$t("MENORGUARDAJUDICIAL"), value: "MENORGUARDAJUDICIAL" },
        { text: this.$t("PESSOAINCAPAZ"), value: "PESSOAINCAPAZ" },
        { text: this.$t("EXCONJUGUE"), value: "EXCONJUGUE" },
        { text: this.$t("AGREGADOOUTROS"), value: "AGREGADOOUTROS" },
      ],
      itensServidorCategoria: [
        { text: this.$t("EFETIVO"), value: "EFETIVO" },
        { text: this.$t("ESTATUARIO"), value: "ESTATUARIO" },
        { text: this.$t("COMISSIONADO"), value: "COMISSIONADO" },
        { text: this.$t("CLT"), value: "CLT" },
        { text: this.$t("ESTAGIARIO"), value: "ESTAGIARIO" },
        { text: this.$t("EMPREGADOPUBLICO"), value: "EMPREGADOPUBLICO" },
        { text: this.$t("TEMPORARIO"), value: "TEMPORARIO" },
      ],
    };
  },
  computed: {
    mesAtual() {
      return mesCorrente();
    },
    mesAdmissao() {
      return this.recurso.admissao
        ? String(this.recurso.admissao).substring(0, 7)
        : undefined;
    },
    // Salário ou unidade diferentes dos carregados: o novo salário entra no histórico a partir da competência.
    salarioAlterado() {
      if (!this.recurso.id) return false;
      const novo = numeroSalario(this.recurso.salarioBase);
      return (
        novo !== null &&
        (novo !== this.salarioOriginal ||
          (this.recurso.salarioUnidade || null) !==
            (this.salarioUnidadeOriginal || null))
      );
    },
    headerHistoricoSalarios() {
      return [
        {
          text: this.$t("Competencia_inicio"),
          value: "competencia",
          sortable: false,
        },
        { text: this.$t("Salario_base"), value: "salario", sortable: false },
        {
          text: this.$t("Salario_anterior"),
          value: "salarioAnterior",
          sortable: false,
        },
        { text: this.$t("Origem"), value: "origemDescricao", sortable: false },
        {
          text: this.$t("Alterado_por"),
          value: "responsavel",
          sortable: false,
        },
        { text: this.$t("Alterado_em"), value: "dtInclusao", sortable: false },
      ];
    },
    isOrgaoPublico() {
      return this.$store?.state?.inquilino?.tipoContratacao === "ORGAOPUBLICO";
    },
    exigePeriodoExperiencia() {
      return (
        this.recurso.contratoTipo &&
        this.recurso.contratoTipo !== "INTERMITENTE"
      );
    },
    camposObrigatorios() {
      const campos = ["pessoa", "matricula", "nomeSocial", "contratoTipo"];

      if (this.exigePeriodoExperiencia) {
        campos.push("experienciaTermino1", "experienciaTermino2");
      }

      if (this.recurso.status === "DESLIGADO") {
        campos.push("dtDesligamento");
      }

      return campos;
    },
  },

  watch: {
    "recurso.id": {
      immediate: true,
      handler() {
        this.salarioOriginal = numeroSalario(this.recurso.salarioBase);
        this.salarioUnidadeOriginal = this.recurso.salarioUnidade || null;
        this.competenciaSalario = mesCorrente();
      },
    },
    salarioAlterado() {
      this.sincronizarCompetenciaSalario();
    },
    competenciaSalario() {
      this.sincronizarCompetenciaSalario();
    },
  },

  mounted() {
    console.log("Valor da categoria (tipo):", this.recurso.cnhCategoria);

    //this.getPessoas();
    this.getEstados();

    this.getFuncionarioSindicatos();
    //this.getRecurso();
  },

  methods: {
    emitSubmitSuccess(recursoAtualizado = this.recurso) {
      this.$emit("submitSuccess", recursoAtualizado);
    },
    emitSubmitError() {
      this.$emit("submitError");
    },
    closeModalEdit() {
      this.$emit("closeModalEdit");
    },
    submitForm() {
      const recurso = {
        ...this.recurso,
        servidorCategoria: this.isOrgaoPublico
          ? this.recurso.servidorCategoria
          : null,
      };

      DataService.update(this.limpaMascara(recurso))
        .then(() => {
          this.erros = [];
          this.submited = true;
        })
        .catch((error) => {
          window.scrollTo({ top: 0, left: 0, behavior: "smooth" });

          this.errors = error.response.data.errors;
        });
    },

    // Só vai ao servidor quando o salário muda (sem ela, o novo salário vale do mês atual).
    sincronizarCompetenciaSalario() {
      this.$set(
        this.recurso,
        "salarioCompetencia",
        this.salarioAlterado && this.competenciaSalario
          ? `${this.competenciaSalario}-01`
          : null
      );
    },
    async abrirHistoricoSalarios() {
      this.modalHistoricoSalarios = true;
      this.carregandoHistoricoSalarios = true;
      try {
        const r = await DataService.getSalarios(this.recurso.id);
        this.historicoSalarios = r.data;
      } catch (e) {
        this.historicoSalarios = [];
      } finally {
        this.carregandoHistoricoSalarios = false;
      }
    },
    moedaSalario(valor) {
      return Number(valor || 0).toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
      });
    },
    mesSalario(data) {
      const [a, m] = String(data).substring(0, 7).split("-");
      return `${m}/${a}`;
    },
    dataHoraSalario(valor) {
      if (!valor) return "-";
      const [d, h] = String(valor).split("T");
      const [a, m, dia] = d.split("-");
      return `${dia}/${m}/${a}${h ? " " + h.substring(0, 5) : ""}`;
    },
    formatarData(dataIso) {
      if (!dataIso) return "";
      const data = new Date(dataIso);
      return data.toLocaleDateString("pt-BR"); // retorna "dd/mm/aaaa"
    },
    formatarValor(valor) {
      if (typeof valor !== "number") return valor;
      return valor.toFixed(2).replace(".", ",");
    },

    getEnderecoCep() {
      return this.recurso?.pessoa;
    },

    getEstados() {
      DataService.getEstados()
        .then((response) => {
          this.estados = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getFuncionarioSindicatos() {
      DataService.getFuncionarioSindicatos()
        .then((response) => {
          this.itensSindicato = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    toggleMatriculaAutomatica(event) {
      if (event) {
        this.recurso.matricula = 0;
        this.matriculaAutomatica = true;
      } else {
        this.matriculaAutomatica = false;
      }
    },

    addFone() {
      this.foneCount++;
      this.recurso.pessoa.telefones.push("");
    },

    removeFone() {
      this.foneCount--;
      this.recurso.pessoa.telefones.pop();
    },

    getRecurso() {
      DataService.find(this.recurso.id)
        .then((response) => {
          this.recurso = response.data;
        })
        .catch((error) => {
          window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
          console.log(error);
          this.errors.push({ field: "ID", message: "não encontrado" });
        });
    },

    showHistoricoBeneficios(recurso) {
      console.log("showHistoricoBeneficios", recurso);
      this.modalHistoricoBeneficios = true;
      ComumDataService.get("beneficioApuracao/funcionario/" + recurso.pessoa, {
        params: {},
      })
        .then((res) => {
          this.listagemHistoricoBeneficios = res.data;
          console.log(
            "listagemHistoricoBeneficios",
            this.listagemHistoricoBeneficios
          );
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    showHistoricoSaldobancohoras(recurso) {
      this.modalHistoricoSaldoBancoHoras = true;
      ComumDataService.get(
        "funcionarioPontoCalculos/folhaPonto/saldoBancoHoras/" +
          recurso.pessoa.id,
        {
          params: {},
        }
      )
        .then((res) => {
          this.listagemHistoricoSaldobancohoras = res.data;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },

    showBeneficiosOptante(recurso) {
      console.log("showHistoricoBeneficios", recurso);

      ComumDataService.get(
        "beneficioConvenioOptante/funcionario/" + recurso.id,
        {
          params: {},
        }
      )
        .then((res) => {
          this.listagemBeneficiosOptante = res.data;
          console.log(
            "listagemBeneficiosOptante",
            this.listagemBeneficiosOptante
          );
          this.loading = false;
          this.modalBeneficiosOptante = true;
        })
        .catch(() => {
          this.loading = false;
        });
    },

    showDocumentacaoAcessoria(recurso) {
      this.loading = true;
      this.documentacaoAcessoriaSelecionada = [];
      this.modalDocumentacaoAcessoria = true;
      ComumDataService.get(
        "funcionarioDocumentacaoAcessoria/matricula/" + recurso.matricula,
        {
          params: {},
        }
      )
        .then((res) => {
          this.listagemDocumentacaoAcessoria = res.data;
          // console.log(
          //   "listagemHistoricoBeneficios",
          //   this.listagemDocumentacaoAcessoria
          // );
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    closeModalDocumentacaoAcessoria() {
      this.documentacaoAcessoriaSelecionada = [];
      this.modalDocumentacaoAcessoria = false;
    },

    showGed() {
      this.mostrarArquivadosGed = false;
      this.reloadFilesGed();
      this.modalGed = true;
    },

    alternarArquivadosGed() {
      this.mostrarArquivadosGed = !this.mostrarArquivadosGed;
      if (this.mostrarArquivadosGed) this.reloadArquivadosGed();
    },

    reloadArquivadosGed() {
      ComumDataService.get(
        "funcionarioGed/arquivados/matricula/" + this.recurso.matricula
      ).then((res) => {
        this.gedArquivados = res.data;
      }).catch(() => {
        this.$swal.fire(this.$t("Erro"), this.$t("ged_erro_carregar"), "error");
      });
    },

    reloadFilesGed() {
      ComumDataService.get(
        "funcionarioGed/matricula/" + this.recurso.matricula,
        {
          params: {},
        }
      )
        .then((res) => {
          this.listagemGed = res.data;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },

    printSingle(recurso) {
      this.loading = true;

      ComumDataService.get(
        "funcionarioDocumentacaoAcessoria/print/" + recurso.id,
        {
          responseType: "blob",
        }
      )
        .then((res) => {
          this.loading = false;
          this.download(res.data, "document.pdf", "application/pdf");
          this.$swal.fire(
            this.$t("Sucesso"),
            this.$t("Documento_gerado_com_sucesso"),
            "success"
          );
        })
        .catch(() => {
          this.loading = false;
          this.$swal.fire(
            this.$t("Erro"),
            this.$t("Falha_ao_exportar"),
            "error"
          );
        });
    },
    printSelectedDocumentacaoAcessoria() {
      const ids = this.getDocumentacaoAcessoriaSelecionadaIds();
      if (!ids.length) {
        this.$swal.fire(
          this.$t("Atencao"),
          this.$t("Nenhum_registro_para_impressao"),
          "warning"
        );
        return;
      }

      this.loading = true;
      ComumDataService.post(
        "funcionarioDocumentacaoAcessoria/print",
        { ids },
        {
          responseType: "blob",
        }
      )
        .then((res) => {
          this.download(
            res.data,
            "documentacao-acessoria-selecionada.pdf",
            "application/pdf"
          );
          this.$swal.fire(
            this.$t("Sucesso"),
            this.$t("Documento_gerado_com_sucesso"),
            "success"
          );
        })
        .catch(() => {
          this.$swal.fire(
            this.$t("Erro"),
            this.$t("Falha_ao_exportar"),
            "error"
          );
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getDocumentacaoAcessoriaSelecionadaIds() {
      const ids = [];
      const idsSet = new Set();
      this.documentacaoAcessoriaSelecionada.forEach((item) => {
        const id = item && item.id;
        if (id === undefined || id === null || idsSet.has(id)) {
          return;
        }
        idsSet.add(id);
        ids.push(id);
      });
      return ids;
    },

    download(content, fileName, mimeType) {
      var a = document.createElement("a");
      mimeType = mimeType || "application/octet-stream";

      if (navigator.msSaveBlob) {
        // IE10
        navigator.msSaveBlob(
          new Blob([content], {
            type: mimeType,
          }),
          fileName
        );
      } else if (URL && "download" in a) {
        //html5 A[download]
        a.href = URL.createObjectURL(
          new Blob([content], {
            type: mimeType,
          })
        );
        a.setAttribute("download", fileName);
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      } else {
        location.href =
          "data:application/octet-stream," + encodeURIComponent(content); // only this mime type is supported
      }
    },

    getPessoas() {
      ComumDataService.get("/pessoas").then((res) => {
        this.pessoas = res.data;
      });
    },

    possuiGed() {
      try {
        let param = this.$store.state.inquilino.modulosContratacao.find(
          (item) => {
            return item.tipo == "GED";
          }
        );
        if (param != undefined && param.id != undefined) {
          return true;
        } else {
          return false;
        }
      } catch (err) {
        return false;
      }
    },

    newDocGedFunction() {
      this.$refs.form.validate();
      if (this.descricao.length === 0) {
        alert("O campo 'Descrição' é obrigatório.");
        return;
      }

      if (this.descricao.length < 5) {
        alert("O campo 'Descrição' deve ter pelo menos 5 caracteres.");
        return;
      }

      if (this.descricao.length > 50) {
        alert("O campo 'Descrição' deve ter no máximo 50 caracteres.");
        return;
      }

      if (this.file === null) {
        alert("O campo 'Arquivo' é obrigatório.");
        return;
      }

      // Valida o tamanho do arquivo
      if (this.file.size > 3145728) {
        alert("O arquivo não pode exceder 3.0 megabyte.");
        return;
      }

      this.loading = true;

      const formData = new FormData();
      formData.append("file", this.file);
      formData.append("matricula", this.recurso.matricula);
      formData.append("descricao", this.descricao);

      ComumDataService.post("funcionarioGed", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
        .then(() => {
          this.reloadFilesGed();
          this.loading = false;
          this.closeModalNewGed();
        })
        .catch((err) => {
          this.loading = false;
          alert(err.response.data.message);
        });
    },
    closeModalNewGed() {
      this.modalNewDocGed = false;
      this.newDocGed.descricao = "";
      this.newDocGed.dataMinimaArmazenamentoFisico = null;
      this.newDocGed.matricula = "";
      this.newDocGed.file = null;
    },

    changeFile(event) {
      this.file = event;
      console.log("this.newDocGed.file", this.file);
    },

    abrirHistoricoGed(item) {
      this.gedSelecionado = item;
      this.modalHistoricoGed = true;
    },

    async downloadAnexo(item) {
      this.loading = true;
      try {
        const response = await FuncionarioGedDataService.baixar(item.id);
        FuncionarioGedDataService.salvarDownload(response, item.nomeArquivo);
      } catch (error) {
        this.$swal.fire(this.$t("Erro"), this.$t("ged_erro_baixar"), "error");
      } finally {
        this.loading = false;
      }
    },

    async abrirEnderecoGed(id) {
      const janela = window.open("about:blank", "_blank");
      if (janela) janela.opener = null;
      try {
        const url = await FuncionarioGedDataService.consultarEndereco(id);
        if (!url) throw new Error("Endereço indisponível");
        if (janela) janela.location.replace(url);
        else window.location.assign(url);
      } catch (error) {
        if (janela) janela.close();
        this.$swal.fire(this.$t("Erro"), this.$t("ged_erro_baixar"), "error");
      }
    },

    deleteAnexo(obj) {
      this.loading = true;
      ComumDataService.delete("funcionarioGed/" + obj.id, {})
        .then(() => {
          this.reloadFilesGed();
          this.reloadArquivadosGed();
          this.loading = false;
          //this.closeModalNewGed();
          this.$swal.fire(
            this.$t("Sucesso"),
            this.$t("ged_arquivado_sucesso"),
            "success"
          );
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
          alert(err.response.data.message);
        });
    },

    restaurarGed(obj) {
      this.loading = true;
      ComumDataService.put("funcionarioGed/" + obj.id + "/restaurar", {})
        .then(() => {
          this.reloadFilesGed();
          this.reloadArquivadosGed();
          this.$swal.fire(this.$t("Sucesso"), this.$t("ged_restaurado_sucesso"), "success");
        })
        .catch((err) => {
          this.$swal.fire(this.$t("Erro"), err?.response?.data?.message || this.$t("ged_erro_carregar"), "error");
        })
        .finally(() => { this.loading = false; });
    },

    possuiParametrizacaoInquilino(parametrizacao) {
      return this.$store.state.inquilino.parametrizacoes.some(
        (item) => item.tipo == parametrizacao
      );
    },
  },
};
</script>

<style scoped></style>
